import React from 'react'
import classNames from 'classnames'
import { FormattedMessage } from 'react-intl'

export default class MSRBanner extends React.Component {

  render() {
    const { locale } = this.props;
    const image = <img src={ locale === 'en' ? '/assets/images/sbux-rewards/header_cn_2024_04_10.png' : '/assets/images/sbux-rewards/header_cn_2024_04_10.png' } />

    return (
      <div>
        <section className='hero account-welcome-msr'>
          {window.location.href.indexOf('/account/register') !== -1 ?
            image :
            <a className="ga-banner-register" id="msr-learn-more" href={ locale === 'en' ? '/en/account/register' : '/account/register' }>
              {image}
            </a>
          }
        </section>
      </div>
    )
  }
}
